export const captainAttributes = ['id', 'email'];
